import { activeTopicIndex, followActiveTopic, prepareTopicSidebar, topicReadingLine } from './page-topics';

export function mountIndustryNavigation(root = document) {
	const menu = root.querySelector(".industry-nav, .service-nav, [data-service-navigation]");
	if (!menu) return;
	prepareTopicSidebar(menu);
	const links = Array.from(menu.querySelectorAll('a[href^="#"]'));
	if (menu.matches("[data-service-navigation]")) {
		links.forEach((link) => link.addEventListener("click", (event) => event.stopPropagation()));
	}
	const sections = links.map((link) => root.querySelector(link.getAttribute("href")));
	const mainNav = root.querySelector("[data-solufy-nav], .solufy-nav");
	let scheduled = false;
	let prevCurrent = -1;

	const syncNavState = () => {
		const isHidden = mainNav && (mainNav.classList.contains("is-hidden") || document.body.classList.contains("is-main-nav-hidden"));
		menu.classList.toggle("is-top", Boolean(isHidden));
	};

	const update = () => {
		scheduled = false;
		syncNavState();
		const firstSection = sections.find(Boolean);
		const anchorMargin = firstSection ? Number.parseFloat(getComputedStyle(firstSection).scrollMarginTop) || 0 : 0;
		const marker = menu.matches("[data-service-navigation]")
			? Math.max(topicReadingLine(), anchorMargin + 2)
			: menu.getBoundingClientRect().bottom + (menu.matches(".industry-nav") ? 64 : 32);
		const current = activeTopicIndex(sections, marker);
		links.forEach((link, index) => {
			if (index === current) link.setAttribute("aria-current", "location");
			else link.removeAttribute("aria-current");
		});

		const activeLink = links[current];
		followActiveTopic(menu, activeLink);
		if (activeLink && current !== prevCurrent) {
			prevCurrent = current;
			const navScrollable = menu.querySelector(".industry-nav__inner, .service-nav__inner") || menu;
			if (navScrollable.scrollWidth > navScrollable.clientWidth) {
				const targetLeft = activeLink.offsetLeft - (navScrollable.clientWidth - activeLink.clientWidth) / 2;
				navScrollable.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
			}
		}
	};

	const schedule = () => {
		if (scheduled) return;
		scheduled = true;
		window.requestAnimationFrame(update);
	};

	if (mainNav) {
		const observer = new MutationObserver(schedule);
		observer.observe(mainNav, { attributes: true, attributeFilter: ["class"] });
	}

	menu.addEventListener("transitionend", schedule);
	window.addEventListener("scroll", schedule, { passive: true });
	window.addEventListener("resize", schedule);
	update();
}
